<div class="container-fluid property-page">
  <app-findProperty [title]="'PropertySearch.FindProperty' | translate"
                    (ParcelItem)="getAddress($event)"></app-findProperty>
  <div class="info-bar">
    <p class="">{{ 'PropertySearch.AdditionalInfo' | translate }}</p>
    <p><a target="_blank" href="https://portal.assessor.lacounty.gov">{{ 'PropertySearch.AssessorPortal' | translate }}
      :</a> {{ 'PropertySearch.AssessorPortalDescription' | translate }}</p>
    <p><a target="_blank" href="https://maps.assessor.lacounty.gov">{{ 'PropertySearch.PIASDescription' | translate }}
      :</a> {{ 'PropertySearch.PIAS' | translate }}</p>
    <p><a target="_blank" href="https://propertytax.lacounty.gov">{{ 'PropertySearch.PropertyTaxPortal' | translate }}
      :</a> {{ 'PropertySearch.PropertyTaxPortalDescription' | translate }}</p>

  </div>

  <accordion [isAnimated]="true">
    <accordion-group *ngIf="parcelItem" [isOpen]="true" #drop>
      <div accordion-heading>
        <span class="dropdown-item clearfix">
          {{ 'PropertySearch.Summary' | translate }} <i class="mt-1 float-end"
                                                        [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
        </span>
      </div>
      <div>
        <h5>AIN: {{ parcelItem.AIN }}</h5>
      </div>
      <hr>
      <div class="row">
        <div class="col">
          <h5 class="sub-title">{{ 'PropertySearch.SitusAddress' | translate }}</h5>
          <p>{{ parcelItem.SitusStreet }}</p>
          <p>{{ parcelItem.SitusCity }}, {{ parcelItem.SitusZipCode }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-12 pr-3">
          <p><strong>{{ 'PropertySearch.UseType' | translate }}</strong> <span
            class="float-end">{{ parcelItem.UseType }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.ParcelType' | translate }}</strong> <span
            class="float-end">{{ parcelItem.ParcelType }}</span></p>
          <p><strong>{{ 'PropertySearch.TaxRateArea' | translate }}</strong> <span
            class="float-end">{{ parcelItem.TaxRateArea }}</span></p>
        </div>
        <div class="col-md-4 col-12 px-3">
          <p><strong>{{ 'PropertySearch.ParcelStatus' | translate }}</strong> <span
            class="float-end">{{ parcelItem.ParcelStatus }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.CreateDate' | translate }}</strong> <span
            class="float-end">{{ parcelItem.CreateDate }}</span></p>
          <p><strong>{{ 'PropertySearch.DeleteDate' | translate }}</strong> <span
            class="float-end">{{ parcelItem.DeleteDate }}</span></p>
        </div>
        <div class="col-md-4 col-12 pl-3">
          <p><strong>{{ 'PropertySearch.TaxStatus' | translate }}</strong> <span
            class="float-end">{{ parcelItem.TaxStatus }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.YearDefaulted' | translate }}</strong> <span
            class="float-end">{{ parcelItem.TaxDefaultedYear }}</span></p>
          <p><strong>{{ 'PropertySearch.Exemption' | translate }}</strong> <span
            class="float-end">{{ parcelItem.Exemption }}</span></p>

          <div class="border-item" style="background-color: #f8f870; display: flex; gap: 10px; align-items: center; justify-content: space-between" [ngbTooltip]="'PropertySearch.MncStatusTooltip' | translate">
            <p><strong>{{ 'PropertySearch.MncStatusLabel' | translate }}</strong></p>
            <p class="float-end" style="text-transform: uppercase; white-space: nowrap;">{{ parcelItem.MncClaimStatus ?? 'N/A' }}</p>
          </div>
        </div>
      </div>
      <div>
        <h5 class="sub-title">{{ 'PropertySearch.Overview' | translate }}</h5>
      </div>
      <div class="row my-4 clearfix">
        <div class="col-md-4 col-sm-6 pr-sm-3">
          <p><strong>{{ 'PropertySearch.UseCode' | translate }}</strong> <span
            class="float-end">{{ parcelItem.UseCode }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.DesignType' | translate }}</strong> <span
            class="float-end">{{ parcelItem.DesignType }}</span></p>
          <p><strong>{{ 'PropertySearch.QualityClass' | translate }}</strong> <span
            class="float-end">{{ parcelItem.QualityClass }}</span></p>
        </div>
        <div class="col-md-4 col-12 px-3">
          <p><strong>{{ 'PropertySearch.Units' | translate }}</strong> <span
            class="float-end">{{ parcelItem.NumOfUnits }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.Beds/Baths' | translate }}</strong> <span
            class="float-end">{{ parcelItem.NumOfBeds }}/{{ parcelItem.NumOfBaths }}</span></p>
          <p><strong>Building SqFt:</strong> <span class="float-end">{{ parcelItem.SqftMain }}</span></p>
        </div>
        <div class="col-md-4 col-12 pl-3">
          <p><strong>{{ 'PropertySearch.UseCode' | translate }}</strong> <span
            class="float-end">{{ parcelItem.UseCode }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.DesignType' | translate }}</strong> <span
            class="float-end">{{ parcelItem.DesignType }}</span></p>
          <p><strong>Land SqFt:</strong> <span
            class="float-end">{{ calculateLand(parcelItem.LandWidth, parcelItem.LandDepth) }}</span></p>
        </div>

      </div>
      <div class="col-md-3 col-sm-6">
        <a href="{{parcelAddress + parcelItem.AIN.substr(0,4) + '-' + parcelItem.AIN.substr(4,3)}}"
           target="_blank">{{ 'PropertySearch.ParcelMap' | translate }}</a>
        / <a href="{{parcelAddress + parcelItem.AIN.substr(0,4) + '-NDX'}}"
             target="_blank">{{ 'PropertySearch.MapIndex' | translate }}</a>
      </div>
      <div>
        <h5 class="sub-title">{{ 'PropertySearch.AssessmentValues' | translate }}</h5>
      </div>
      <div class="row roll-table pr-0">
        <table class="table">
          <thead class="thead">
          <th scope="col"></th>
          <th scope="col">{{ parcelItem.RollPreparation_BaseYear }} {{ 'PropertySearch.RollPrep' | translate }}</th>
          <th scope="col">{{ parcelItem.CurrentRoll_BaseYear }} {{ 'PropertySearch.CurrentRoll' | translate }}</th>
          <th scope="col">RC</th>
          <th scope="col">{{ 'PropertySearch.YEAR' | translate }}</th>
          <th scope="col">{{ parcelItem.BaseValue_Year }} {{ 'PropertySearch.BaseYear' | translate }}</th>
          </thead>
          <tbody>
          <th>{{ 'PropertySearch.Land' | translate }}</th>
          <td>{{ parcelItem.RollPreparation_LandValue | currency }}</td>
          <td>{{ parcelItem.CurrentRoll_LandValue | currency }}</td>
          <td>{{ parcelItem.CurrentRoll_LandReasonCode }}</td>
          <td>{{ parcelItem.CurrentRoll_LandBaseYear }}</td>
          <td>{{ parcelItem.BaseValue_Land | currency }}</td>
          </tbody>
          <tbody>
          <th>{{ 'PropertySearch.Improvements' | translate }}</th>
          <td>{{ parcelItem.RollPreparation_ImpValue| currency }}</td>
          <td>{{ parcelItem.CurrentRoll_ImpValue | currency }}</td>
          <td>{{ parcelItem.CurrentRoll_ImpReasonCode }}</td>
          <td>{{ parcelItem.CurrentRoll_ImpBaseYear }}</td>
          <td>{{ parcelItem.BaseValue_Imp | currency }}</td>
          </tbody>
          <tbody class="border-last">
          <th>{{ 'PropertySearch.Total' | translate }}</th>
          <td>{{ calculate(parcelItem.RollPreparation_ImpValue, parcelItem.RollPreparation_LandValue) | currency }}</td>
          <td>{{ calculate(parcelItem.CurrentRoll_ImpValue, parcelItem.CurrentRoll_LandValue) | currency }}</td>
          <td></td>
          <td></td>
          <td>{{ calculate(parcelItem.BaseValue_Land, parcelItem.BaseValue_Imp) | currency }}</td>
          </tbody>
        </table>

      </div>
      <p><strong [innerHTML]="'PropertySearch.Note' | translate"></strong></p>
      <div>
        <h5 class="sub-title">{{ 'PropertySearch.ResponsibleDivision' | translate }}</h5>
      </div>
      <div class="row">
        <div class="col-md-4 col-12 pl-md-3">
          <p class="float-left"><strong>{{ 'PropertySearch.District' | translate }}</strong></p>
          <div>
            <p>{{ parcelItem.DistrictOffice }}</p>
            <p class="border-item">{{ parcelItem.OfficeStreet }}</p>
            <p>{{ parcelItem.OfficeCity }} {{ parcelItem.OfficeZipCode }}</p>
          </div>
        </div>
        <div class="col-md-4 col-12 px-md-3">
          <p><strong>{{ 'PropertySearch.Phone' | translate }}</strong> <span
            class="float-end">{{ parcelItem.OfficePhone }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.TollFree' | translate }}</strong> <span
            class="float-end">{{ parcelItem.OfficeTollFree }}</span></p>
          <p><strong>{{ 'PropertySearch.Hours' | translate }}</strong> <span
            class="float-end">{{ parcelItem.OfficeHours }}</span></p>
        </div>
        <div class="col-md-4 col-12 pr-md-3">
          <p><strong>{{ 'PropertySearch.Region' | translate }}</strong> <span
            class="float-end">{{ parcelItem.Region }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.Cluster' | translate }}</strong> <span
            class="float-end">{{ parcelItem.Cluster }}</span></p>
        </div>
      </div>
    </accordion-group>
    <accordion-group *ngIf="parcelItem" #drop2 [isOpen]='false'>
      <div accordion-heading>
        <span class="dropdown-item clearfix">
          {{ 'PropertySearch.Characteristics' | translate }} <i class="mt-1 float-end"
                                                                [ngClass]="!drop2.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>

        </span>
      </div>
      <div>
        <h5 class="sub-title">{{ 'PropertySearch.LandInformation' | translate }}</h5>
      </div>
      <div *ngIf="parcelItem" class="row land-information">
        <div class="col-md-4 col-12 pl-3">
          <p><strong>{{ 'PropertySearch.UseCode' | translate }}</strong> {{ parcelItem.UseCode }}
            ({{ parcelItem.UseCode2ndDigit }})</p>
          <p class="">{{ parcelItem.UseCode[0] }}: {{ parcelItem.UseCode1stDigit }}</p>
          <p class="">{{ parcelItem.UseCode[1] }}: {{ parcelItem.UseCode2ndDigit }}</p>
          <p class="">{{ parcelItem.UseCode[2] }}: {{ parcelItem.UseCode3rdDigit }}</p>
          <p class="">{{ parcelItem.UseCode[3] }}: {{ parcelItem.UseCode4thDigit }}</p>
        </div>
        <div class="col-md-4 col-12 px-md-3">
          <p><strong>{{ 'PropertySearch.Total' | translate }} SqFt(GIS):</strong> <span class="float-end">0</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.Total' | translate }} SqFt(PDB):</strong> <span
            class="float-end">{{ parcelItem.LandWidth * parcelItem.LandDepth }}</span></p>
          <p><strong>{{ 'PropertySearch.Usable' | translate }} SqFt:</strong> <span
            class="float-end">{{ parcelItem.UsableSqftLot }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.Acres' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.LandAcres }}</span></p>
          <p><strong>{{ 'PropertySearch.Land' | translate }} W'xD':</strong> <span
            class="float-end">{{ parcelItem.LandWidth }} x {{ parcelItem.LandDepth }}</span></p>
        </div>
        <div class="col-md-4 col-12 px-md-3">
          <p><strong>{{ 'PropertySearch.Sewers' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.LotSewer }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.FlightPath' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.LotFlight }}</span></p>
          <p><strong>X-Traffic:</strong> <span class="float-end">{{ parcelItem.LotTraffic }}</span></p>
          <p style="border-bottom: 0;" class="border-item"><strong>Freeway:</strong> <span
            class="float-end">{{ parcelItem.LotFreeway }}</span></p>
        </div>
        <div class="col-md-4 col-12">
          <p><strong>{{ 'PropertySearch.CornerLot' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.LotCorner }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.GolfFront' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.LotGolf }}</span></p>
          <p><strong>{{ 'PropertySearch.HorseLot' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.LotHorse }}</span></p>
          <p style="border-bottom: 0;" class="border-item"><strong>{{ 'PropertySearch.View' | translate }}:</strong>
            <span class="float-end">{{ parcelItem.LotView }}</span></p>
        </div>
        <div class="col-md-4 col-12 px-md-3">
          <p><strong>{{ 'PropertySearch.Zoning' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.ZoningPDB }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.CodeSplit' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.LotCodeSplit }}</span></p>
          <p><strong>{{ 'PropertySearch.Impairment' | translate }}:</strong> <span
            class="float-end">{{ parcelItem.LotImpairment }}</span></p>
        </div>
        <div class="col-12">
          <p><strong>{{ 'PropertySearch.LegalDescription' | translate }}</strong>
            ({{ 'PropertySearch.ForAssessment' | translate }}):</p>
          <p>{{ parcelItem.LegalDescription }}</p>
        </div>
      </div>
      <div style="border-bottom: 2px solid #043c5a;">
        <h5 class="sub-title ">{{ 'PropertySearch.BuildingInformation' | translate }}</h5>
      </div>

      <div *ngFor="let part of parcelItem.SubParts" class="row building-information mb-3">

        <div class="col-md-4 col-12 pl-3">
          <p><strong>{{ 'PropertySearch.DesignType' | translate }}</strong> ({{ parcelItem.DesignType }})</p>
          <p class="">{{ parcelItem.DesignType[0] }}: {{ (part).DesignType1stDigit }}</p>
          <p class="">{{ parcelItem.DesignType[1] }}: {{ (part).DesignType2ndDigit }}</p>
          <p class="">{{ parcelItem.DesignType[2] }}: {{ (part).DesignType3rdDigit }}</p>
          <p class="">{{ parcelItem.DesignType[3] }}: {{ (part).DesignType4thDigit }}</p>
        </div>
        <div class="col-md-4 col-12 px-md-3">
          <p><strong>{{ 'PropertySearch.Subpart' | translate }}:</strong> <span
            class="float-end">{{ (part).SubPartNumber }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.DesignType' | translate }}</strong> <span
            class="float-end">{{ (part).DesignType }}</span></p>
          <p><strong>{{ 'PropertySearch.QualityClass' | translate }}</strong> <span
            class="float-end">{{ (part).QualityClass }}</span></p>
        </div>
        <div class="col-md-4 col-12 px-md-3">
          <p><strong>{{ 'PropertySearch.Units' | translate }}</strong> <span
            class="float-end">{{ (part).NumOfUnits }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.Beds/Baths' | translate }}</strong> <span
            class="float-end">{{ (part).NumOfBeds }}/{{ (part).NumOfBaths }}</span></p>
          <p><strong>{{ 'PropertySearch.Building' | translate }} SqFt:</strong> <span
            class="float-end">{{ (part).SqftMain }}</span></p>
        </div>
        <div class="col-md-4 col-12">
          <p><strong>{{ 'PropertySearch.Year' | translate }} Built:</strong> <span
            class="float-end">{{ (part).YearBuilt }}</span></p>
          <p class="border-item"><strong>{{ 'PropertySearch.EffectiveYear' | translate }}:</strong> <span
            class="float-end">{{ (part).EffectiveYear }}</span></p>
          <p><strong>{{ 'PropertySearch.Depreciation' | translate }}:</strong> <span
            class="float-end">{{ (part).Depreciation }}/{{ (part).DepreciationType }}
            /{{ (part).AddedDepreciationPercent }}</span></p>
        </div>
        <div class="col-md-4 col-12 px-md-3">
          <p><strong>RCN Other:</strong> <span class="float-end">{{ (part).RCNOther }}</span></p>
          <p class="border-item"><strong>RCN Other Trended:</strong> <span
            class="float-end">{{ (part).RCNOtherTrended }}</span></p>
          <p><strong>{{ 'PropertySearch.YearChange' | translate }}:</strong> <span
            class="float-end">{{ (part).RCNYearChange }}</span></p>
        </div>
        <hr>
      </div>

    </accordion-group>
    <!-- <accordion-group #drop2>
      <div accordion-heading >
        <span class="dropdown-item clearfix">
          Building and Land Characteristics <i class="mt-1 float-end" [ngClass]="!drop2.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>

        </span>
      </div>
      This content is straight in the template.
    </accordion-group> -->


  </accordion>
</div>
